import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  AuthenticationProvider,
  AuthenticationProviderOptions,
} from '@microsoft/microsoft-graph-client';
import { firstValueFrom } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MsalAuthProvider implements AuthenticationProvider {
  public constructor(private readonly msalService: MsalService) {}

  public async getAccessToken(
    authenticationProviderOptions?: AuthenticationProviderOptions | undefined
  ): Promise<string> {
    return await firstValueFrom(
      // msal-browser 3 throws `uninitialized_public_client_application` from
      // acquireTokenSilent until initialize() has resolved. The Graph client calls this
      // during bootstrap (AppComponent.ngOnInit -> loadADUser), which runs before
      // MsalRedirectComponent initializes the instance, so initialize here too — it is
      // idempotent and returns early once done.
      this.msalService.initialize().pipe(
        switchMap(() =>
          this.msalService.acquireTokenSilent({
            scopes: authenticationProviderOptions?.scopes ?? [],
          })
        ),
        map((authResponse) => authResponse.accessToken)
      )
    );
  }
}
